<div class="section-container">
  <div class="text-content">
    <h2>Anuncie seu imóvel com a líder do mercado!</h2>
    <p>
      Na Cancian Imóveis, 2 a cada 3 imóveis anunciados são negociados em até 30 dias. Com
      mais de <b>50 mil acessos mensais</b> no site, a <b>maior vitrine da cidade</b>, unindo
      <b>visibilidade, praticidade e segurança</b> para você negociar com tranquilidade.
    </p>
  </div>
  <div class="form-container">
    <div class="cabecalho-chamada-texto">
      <h3>Comece o seu cadastro</h3>
      <p style="margin: 0!important;">É simples e rápido.</p>
    </div>
    <form [formGroup]="form" (ngSubmit)="enviar()">
      <!-- Nome -->
      <div class="form-group">
        <label for="nome">Nome</label>
        <input type="text" id="nome" name="nome" formControlName="nome" autocomplete="off" />
        <small class="error" *ngIf="submitted && f.nome.invalid">Nome é obrigatório.</small>
      </div>

      <!-- Telefone -->
      <div class="form-group">
        <label for="telefone">Telefone</label>
        <input type="text" id="telefone" formControlName="telefone" mask="(00) 00000-0000" autocomplete="off" />
        <small class="error" *ngIf="submitted && f.telefone.invalid">Telefone é obrigatório.</small>

      </div>

      <!-- E-mail -->
      <div class="form-group">
        <label for="email">E-mail</label>
        <input type="email" id="email" formControlName="email" autocomplete="off" />
        <small class="error" *ngIf="submitted && f.email.errors?.['required']">E-mail é obrigatório.</small>
        <small class="error" *ngIf="submitted && f.email.errors?.['email']">E-mail inválido.</small>
      </div>

      <!-- Endereço -->
      <div class="form-group">
        <label for="endereco">Endereço</label>
        <input type="text" id="endereco" formControlName="endereco" autocomplete="off" />
        <small class="error" *ngIf="submitted && f.endereco.invalid">Endereço é obrigatório.</small>
      </div>

      <!-- Tipo de Imóvel -->
      <div class="form-group">
        <label for="tipoImovel">Tipo de imóvel</label>
        <select id="tipoImovel" name="tipoImovel" formControlName="tipoImovel">
          <option *ngFor="let opcao of destinacoes" [value]="opcao.nomeDestinacao">
            {{ opcao.nomeDestinacao }}
          </option>
        </select>
        <small class="error" *ngIf="submitted && f.tipoImovel.invalid">Tipo de imóvel é obrigatório.</small>

      </div>

      <!-- Valor estimado -->
      <div class="form-group">
        <label for="valor">Valor estimado</label>
        <input type="text" id="valor" formControlName="valor" mask="separator.2" prefix="R$ " thousandSeparator="."
          decimalMarker="," />
        <small class="error" *ngIf="submitted && f.valor.invalid">Valor estimado é obrigatório.</small>

      </div>

      <!-- Mensagem -->
      <div class="form-group full-width">
        <label for="mensagem">Mensagem</label>
        <textarea id="mensagem" formControlName="mensagem" rows="3" cols="50"
          style="border: none; margin:5px;"></textarea>
        <small class="error" *ngIf="submitted && f.mensagem.invalid">Mensagem é obrigatória.</small>

      </div>

      <div class="buttons">
        <button type="submit" class="btn btn-primary" [disabled]="isLoading">
          <span *ngIf="isLoading" class="spinner"></span>
          <span *ngIf="!isLoading">Cadastre seu imóvel</span>
          <span *ngIf="isLoading">Enviando...</span>
        </button>
      </div>
    </form>


  </div>
</div>


<section class="steps-container">
  <div class="content-2" style="margin: auto!important;">
    <h1 class="title">
      Veja como é fácil anunciar:
      <div class="style-div"></div>
    </h1>
  </div>
  <div class="steps">
    <article class="step">
      <div class="step-number">1</div>
      <p class="step-text">Preencha os dados do seu imóvel</p>
    </article>

    <article class="step">
      <div class="step-number">2</div>
      <p class="step-text">Defina um valor para o anúncio</p>
    </article>

    <article class="step">
      <div class="step-number">3</div>
      <p class="step-text">Envie imagens do seu imóvel para começarmos</p>
    </article>

    <article class="step">
      <div class="step-number">4</div>
      <p class="step-text">Deixe que nosso time faz todo o resto para você</p>
    </article>
  </div>
</section>

<app-title title="Perguntas Frequentes"></app-title>
<section class="faq-container">
  <div class="faq">
    <article class="faq-item" *ngFor="let faq of faqs">
      <h3 class="faq-question" (click)="toggleAnswer(faq)">
        {{ faq.pergunta }}
        <span class="faq-icon">
          <i *ngIf="faq.isOpen" class="fa fa-chevron-down"></i>
          <i *ngIf="!faq.isOpen" class="fa fa-chevron-right"></i>
        </span>
      </h3>
      <p class="faq-answer" *ngIf="faq.isOpen">{{ faq.resposta }}</p>
    </article>
  </div>
</section>